/**
 * Regra de reaproveitamento dos últimos totais válidos exibidos nos headers de
 * fornecedor e de categoria.
 *
 * Enquanto o usuário troca o fornecedor de uma linha, os totais passam por um
 * instante zerados (o recálculo ainda não correu para o novo `supplierId`), e
 * segurar o último valor válido evita a piscada. O problema é tratar TODO zero
 * como transitório: zero também é o resultado legítimo de mover a categoria
 * para outra forma de cobrança ou transferi-la para outro fornecedor. Nesse
 * caso o header continuava exibindo o total da categoria que já saiu dali —
 * fornecedor com uma única categoria zerada e header em R$ 89.102,40.
 *
 * O desempate é a posse do CONTEÚDO que gera o total, e conteúdo aqui quer
 * dizer SERVIÇO — não entrada de categoria.
 *
 * A primeira versão desta regra media posse por `addedItemTypeList`, o que
 * bastava para a transferência de CATEGORIA (a entrada sai da origem junto com
 * os serviços). A transferência de SERVIÇO quebrou essa premissa: ela move uma
 * linha só e deixa a categoria vazia na origem de propósito, então a origem
 * continuava "possuindo categoria", o zero real era lido como transitório e o
 * header do fornecedor seguia exibindo o valor do serviço que já tinha saído —
 * só corrigia ao remontar a tela.
 *
 * Medir por serviço cobre os três casos:
 *   - troca de fornecedor da linha: `UPDATE_SUPPLIER_LIST` reescreve o
 *     `supplierId` dos serviços no MESMO dispatch, então a posse continua de pé
 *     e a piscada segue evitada;
 *   - categoria movida/transferida: os serviços saíram, posse cai, zero vale;
 *   - serviço transferido: a categoria fica, mas sem serviço — posse cai.
 */
export function shouldUsePreservedTotals(args: {
  /** Total recalculado agora para esta identidade. */
  currentTotal: number;
  /**
   * A identidade ainda possui algum SERVIÇO que alimente este total, na forma
   * de cobrança e na etapa exibidas? Categoria vazia não conta.
   */
  ownsContent: boolean;
  /** Existe um valor guardado de um render anterior? */
  hasPreserved: boolean;
}): boolean {
  const { currentTotal, ownsContent, hasPreserved } = args;

  // Valor novo é válido: usa ele e atualiza o guardado.
  if (currentTotal > 0) return false;

  // Zero legítimo: não sobrou serviço para somar.
  if (!ownsContent) return false;

  return hasPreserved;
}
